export function average(values: number[]): number {
    return (
        values.reduce(
            (previousValue: number, currentValue: number) =>
                previousValue + currentValue
        ) / values.length
    );
}
